import { render, staticRenderFns } from "./NominationsEditPortal.vue?vue&type=template&id=c43c0df6"
import script from "./NominationsEditPortal.vue?vue&type=script&lang=js"
export * from "./NominationsEditPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports